// Validate redirect URL to prevent open redirect attacks
import { devError } from "@/utils/dev-console";

const ALLOWED_REDIRECT_PATTERNS = [
  /^\/$/,
  /^\/marketplace$/,
  /^\/pricing$/,
  /^\/fee-calculator$/,
  /^\/help$/,
  /^\/blog(\/.*)?$/,
  /^\/compare\/(gumroad|teachable|podia)$/,
  /^\/p\/[^/]+$/,
  /^\/creator\/[^/]+$/,
  /^\/ref\/[^/]+$/,
  /^\/auth\/[^.]+/,
];

export function validateRedirectUrl(url: string): string {
  try {
    const cleanUrl = url.split("?")[0].split("#")[0];

    const isAllowed = ALLOWED_REDIRECT_PATTERNS.some((pattern) =>
      pattern.test(cleanUrl)
    );

    if (isAllowed && !cleanUrl.includes("..") && cleanUrl.startsWith("/")) {
      return cleanUrl;
    }

    return "/";
  } catch (error) {
    devError("Invalid redirect URL", url, error);
    return "/";
  }
}
